import { DataNetworkSwitch } from '@ui/features/Wallet/components/DataNetworkSwitch';
import { WalletConnectButton } from '@ui/features/Wallet/components/WalletConnectButton';
import React from 'react';
import { Flex, FlexProps } from 'styled-system/jsx';

type ConnectWalletProps = FlexProps;

export const ConnectWallet: React.FC<ConnectWalletProps> = ({ ...props }) => {
  return (
    <Flex gap={3} {...props}>
      <WalletConnectButton />
      <DataNetworkSwitch />
    </Flex>
  );
};
